import { render, staticRenderFns } from "./number-formatter.vue?vue&type=template&id=4c74b34e&"
import script from "./number-formatter.vue?vue&type=script&lang=js&"
export * from "./number-formatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports